import React, { useEffect, useState } from "react";
import { Wallet } from "./Wallet";
import { getFirestore, collection, query, where, getDocs, updateDoc } from "firebase/firestore";

export default function BmrCalculator() {
  const [height, setHeight] = useState(50);
  const [heightConversion, setHeightConversion] = useState("4'2'");
  const [heightType, setHeightType] = useState("inch");
  const [weightUnit, setWeightUnit] = useState("kg");
  const [hMax, setHMax] = useState(100);
  const [hMin, setHMin] = useState(30);

  const [wMax, setWMax] = useState(300);
  const [wMin, setWMin] = useState(30);

  const [userId, setUserId] = useState(0);
  const [previewUrl, setPreviewUrl] = useState(""); // For preview
  const [toUploadUrl, setToUploadUrl] = useState("");
  const [DOB, setDOB] = useState("2000-01-01");
  const [name, setName] = useState("");
  const [pic, setPic] = useState("");
  const [gender, setGender] = useState("male");
  const [weight, setWeight] = useState(50);
  const [file, setFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [downloadUrl, setDownloadUrl] = useState("");
  const [uploadingFile, setUploadingFile] = useState(false);
  const [unitPref, setUnitPref] = useState("metric");
  const [formatPref, setFormatPref] = useState("mm/dd/yy");
  const [claimer, setClaimer] = useState(0);
  const [updated, setupdated] = useState(false);
  const [claimed, setClaimed] = useState(false);

  



  const db = getFirestore(); // Initialize Firestore



  const updateTotalCalories = async () => {
    try {
      // Query Firestore for the document with the matching tgUserid
      var newCalories = parseInt(bmr);
      var newEMRS = parseInt(bmr) * 1.5;
      const usersRef = collection(db, "telegram_users");
      const q = query(usersRef, where("tgUserid", "==", tgUserid));
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        // Assuming tgUserid is unique, update the first matching document
        const docRef = querySnapshot.docs[0].ref;
        await updateDoc(docRef, { totalCalories: newCalories,
          gender: gender,
          height: parseInt(height),
          heightUnit: heightType,
          weight: parseInt(weight),
          weightUnit: weightUnit,
          dateOfBirth: DOB + "T00:00:00.000",
          age: parseInt(calculateAge(DOB)),
          refCode: tgUserid
    
        
        });
        console.log("Total calories updated successfully!");  
        global.openTGHome();
      } else {
        console.log("No matching user found.");
      }
    } catch (error) {
      console.error("Error updating totalCalories:", error);
    }
  };



  const updateHeight = (input) => {
    setHeight(input);
    var string = "";
    if (heightType == "inch") {
      const feet = Math.floor(input / 12); // Calculate the whole feet
      const inches = input % 12; // Get the remaining inches
      string = feet + "'" + inches + "'";
    } else {
      const mtrs = Math.floor(input / 100); // Calculate the whole feet
      const cMtrs = input % 100; // Get the remaining inches
      string = mtrs + "." + cMtrs + "m";
    }
    setHeightConversion(string);
  };
  const changeHeightType = (value) => {
    setHeightType(value);
    if (value === "inch") {
      setHMax(100);
      setHMin(30);
    } else {
      setHMax(254);
      setHMin(76);
    }
  };
  const calculateAge = (dateOfBirth) => {
    const today = new Date();
    const birthDate = new Date(dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();
    // Adjust age if the birthday hasn't occurred yet this year
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }
    return age;
  };
  const [bmr, setBmr] = useState(null);
  const calculateBMR = () => {
    //    const { gender, age, weight, height } = formData;
    var age = calculateAge(DOB);
    const ageNum = parseFloat(age);
    var weightNum = parseFloat(weight);
    var heightNum = parseFloat(height);
    if (heightType == "inch") {
      heightNum = heightNum * 2.54;
    }
    if (weightUnit == "pound") {
      weightNum = weightNum * 0.453592;
    }
    let calculatedBMR;
    if (gender === "male") {
      calculatedBMR =
        88.362 + 13.397 * weightNum + 4.799 * heightNum - 5.677 * ageNum;
    } else if (gender === "female") {
      calculatedBMR =
        447.593 + 9.247 * weightNum + 3.098 * heightNum - 4.33 * ageNum;
    } else {
      alert("Invalid gender selected.");
      return;
    }
    setBmr(calculatedBMR.toFixed(2));
  };
  useEffect(() => {
    
    if (updated) {
      calculateBMR();
    }
  }, [DOB, weight, height, gender]);

  const [tgUserid, setTgUserId] = useState(0);
  useEffect(() => {
    setTgUserId(parseInt(localStorage.getItem('TGUSERID')));
  },[]);
  return (
    <div className="section">
      <div
        style={{
          padding: 20,
          textAlign: "left",
          width: "100%",
          position: "relative",
        }}
      >
        <div
          
          style={{
            position: "fixed",
            top: 20,
            left: 20,
            zIndex: 30,
            fontSize: 14,
            fontWeight: "bold",
          }}
        >
          <img src={require("./assets/emorya-logo.png")} style={{
            height:30
          }}/>
        </div>
        <div
          className="gradColor"
          style={{
            position: "absolute",
            top: 20,
            right: 20,
            zIndex: 30,
            display: "flex",
            flexDirection: "row",
            borderRadius: 20,
          }}
        >
          <Wallet renderer={claimer ? claimer : 0}></Wallet>
        </div>
        <div
          style={{
            padding: 20,
            marginTop: 10,
            textAlign: "center",
          }}
        >
          <button
            className="btn btn-sm btn-primary"
            onClick={() => {
              global.goToSignIn();
            }}
            style={{
              padding: "5px 15px",
              borderRadius: 20,
              marginTop: 20,
              width: "auto",
              fontSize: 12,
              backgroundColor: "#4b2b55",
              display:'none'
            }}
          >
            Get started with 1000 $EMRS instantly!
          </button>
        </div>
        <div
          className="row"
          style={{
            width: "100%",
          }}
        >
          <div className="col-12">
            <div
              className="glowBox"
              style={{
                padding: 20,
                marginTop:50
              }}
            >
              <div
                style={{
                  fontSize: 20,
                  fontWeight: "bold",
                  marginBottom: 20,
                }}
              >
                BMR Calculator
              </div>
              <div className="subHeading">Gender</div>
              <br />
              <div
                class="btn-group"
                style={{
                  width: "100%",
                }}
              >
                <button
                  type="button"
                  className={
                    gender == "male"
                      ? "btn btn-primary gradColor"
                      : "btn btn-light glowBox"
                  }
                  style={{
                    width: "50%",
                  }}
                  onClick={() => setGender("male")}
                >
                  Male
                </button>
                <button
                  type="button"
                  className={
                    gender == "female"
                      ? "btn btn-primary gradColor"
                      : "btn btn-primary glowBox"
                  }
                  style={{
                    width: "50%",
                  }}
                  onClick={() => setGender("female")}
                >
                  Female
                </button>
              </div>
              <div
                className="subHeading"
                style={{
                  marginTop: 40,
                }}
              >
                Height
              </div>
              <span
                style={{
                  fontSize: 20,
                  fontWeight: "bold",
                  color: "#fff",
                }}
              >
                {heightConversion}
              </span>
              <div
                style={{
                  float: "right",
                }}
              >
                <span
                  className={
                    heightType == "meter"
                      ? "badge bg-light gradColor"
                      : "badge bg-light glowBox"
                  }
                  onClick={() => {
                    changeHeightType("meter");
                  }}
                  style={{}}
                >
                  Meter
                </span>
                &nbsp; &nbsp;
                <span
                  className={
                    heightType == "inch"
                      ? "badge bg-light gradColor"
                      : "badge bg-light glowBox"
                  }
                  onClick={() => {
                    changeHeightType("inch");
                  }}
                  style={{}}
                >
                  Feet
                </span>
              </div>
              <br />
              <input
                type="range"
                min={hMin}
                max={hMax}
                onInput={(e) => {
                  updateHeight(e.target.value);
                }}
                style={{
                  width: "100%",
                }}
                value={height}
              />
              <div
                className="subHeading"
                style={{
                  marginTop: 30,
                }}
              >
                Weight
              </div>
              <span
            style={{
              fontSize: 20,
              fontWeight: "bold",
            }}
          >
            {weight}
          </span>
              <div
                style={{
                  float: "right",
                }}
              >
                <span
                  className={
                    weightUnit == "kg"
                      ? "badge bg-light gradColor"
                      : "badge bg-light glowBox"
                  }
                  onClick={() => {
                    setWeightUnit("kg");
                  }}
                  style={{}}
                >
                  Kg
                </span>
                &nbsp; &nbsp;
                <span
                  className={
                    weightUnit == "pound"
                      ? "badge bg-light gradColor"
                      : "badge bg-light glowBox"
                  }
                  onClick={() => {
                    setWeightUnit("pound");
                  }}
                  style={{}}
                >
                  Pound
                </span>
              </div>


              <input
                type="range"
                min={wMin}
                max={wMax}
                onInput={(e) => {
                  var x = e.target.value;
                  if(x > 300) x = 300;
                  setWeight(x);

                }}
                style={{
                  width: "100%",
                }}
                value={weight}
              />


              
              <div
                className="subHeading"
                style={{
                  marginTop: 30,
                }}
              >
                Date Of Birth
              </div>
              <input
                className="input"
                type="date"
                value={DOB}
                style={{
                  background: "transparent",
                  fontSize: 20,
                  outline: "none",
                  padding: 0,
                }}
                onChange={(e) => {
                  setupdated(true);
                  setDOB(e.target.value);
                }}
                placeholder=""
              />
              <br />
              <br />
              {bmr ? (
                <>
                  <div>
                    <h2 className="text-xl font-bold text-white">
                      {bmr} kcal/day
                    </h2>
                    = {(bmr * 1.5).toFixed(2)} EMRS - (${" "}
                    {(bmr * 1.5 * 0.0005).toFixed(2)})
                  </div>
                  <br />
                  <button
                    className="btn btn-sm btn-success gradColor"
                    onClick={() => {
                      
                      updateTotalCalories();
                      if (!claimed) {
                        //setClaimer(parseInt(bmr) * 1.5);
                        
                        setClaimed(true);

                      }
                    }}
                  >
                    {claimed ? (
                      <>
                        <i className="fas fa-check"></i>
                        &nbsp; Claimed
                      </>
                    ) : (
                      <>
                        Claim Now&nbsp;
                        <i className="fas fa-angle-right"></i>
                      </>
                    )}
                  </button>
                 
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
